import React, { useContext } from 'react'
import Context from '../../context'
import { FieldRow, HR } from '../../layout/mixins'
import Field from '../Field'
import Dropdown from '../Dropdown'
import { PERMISSIONS_CONTACT_LEVELS } from '../../config/alarmPrivateForm'

export const PermissionRow = ({ nth }) => {
  const { setField, setValue, getValue } = useContext(Context)

  return (
    <>

      <hr />
      <FieldRow slim>
        <Field
          name={`permission_contact_name_${nth}`}
          placeholder="Namn"
          onChange={setField(`permission_contact_name_${nth}`)}
          value={getValue(`permission_contact_name_${nth}`)}
          required
          third
        />
        <Dropdown
          name={`permission_contact_level_${nth}`}
          options={PERMISSIONS_CONTACT_LEVELS}
          onChange={setValue(`permission_contact_level_${nth}`)}
          active={getValue(`permission_contact_level_${nth}`)}
          placeholder="Behörighetsnivå"
          third
          required
        />
        <Field
          name={`permission_contact_code_${nth}`}
          placeholder="Behörighetskod"
          onChange={setField(`permission_contact_code_${nth}`)}
          value={getValue(`permission_contact_code_${nth}`)}
          required
          third
          instructions="Endast siffror, mellan 6-12 st"
          pattern="[0-9]{6,12}"
        />
      </FieldRow>
    </>
  )
}

export default PermissionRow